import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import vuetify from "./plugins/vuetify";
import http, { initializeErrorHandler } from "./plugins/http";
import errorHandler from "./plugins/error-handler";
import "./plugins/global-components";
import "./plugins/global-mixins";
import "./plugins/global-validations";
import vueDebounce from "vue-debounce";
import LogRocket from "logrocket";
if (process.env.ENVIRONMENT !== "development") LogRocket.init("uotsmx/visp");
Vue.use(vueDebounce);
Vue.filter("formatDate", function(value) {
  if (value) {
    return new Date(value).toLocaleDateString("en-AU");
  }
});
Vue.filter("formatDateTime", function(value) {
  if (value) {
    let date = new Date(`${value}`);
    date = new Date(date.toString().replace("Standard", "Daylight"));
    return `${date.toLocaleDateString(
      "en-AU"
    )} ${date.toLocaleTimeString()} AEDT`;
  }
});
Vue.config.productionTip = false;
Vue.prototype.$routes = router.options.routes;
Vue.prototype.$http = http;

// Initialize error handling
initializeErrorHandler(store, router);
Vue.use(errorHandler, { store, router });

new Vue({
  store: store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
